enum MessageType {
	Public = 1,
	Private = 2,
}

export default MessageType;